import React from 'react'

export default function Offers() {
  return (
    <div>Offers</div>
  )
}
